export const hourAndMinuteToStringFormat = (hours, minutes) => {
  if (hours && !minutes) {
    return `${hours}h`
  }

  if (!hours && minutes) {
    return `${minutes}min`
  }

  if (!hours && !minutes) {
    return '-'
  }

  return `${hours}h ${minutes}min`
}



// WEBPACK FOOTER //
// ./src/infrastructure/utils/hourAndMinuteFormatter.ts